import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const ActionTypes = Constants.ActionTypes;

module.exports = {

  receiveMessages(messages, openConversation, id) {
    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGES_LOAD_SUCCESS,
      messages,
      openConversation,
      id,
    });
  },

};
